var map = {
	"./epi-og-image.jpg": "./Content/images/epi-og-image.jpg",
	"./favicons/apple-touch-icon.png": "./Content/images/favicons/apple-touch-icon.png",
	"./favicons/favicon-16x16.png": "./Content/images/favicons/favicon-16x16.png",
	"./favicons/favicon-32x32.png": "./Content/images/favicons/favicon-32x32.png",
	"./src/BacktoTop.png": "./Content/images/src/BacktoTop.png",
	"./src/BacktoTop.svg": "./Content/images/src/BacktoTop.svg",
	"./src/abbvieLogo.png": "./Content/images/src/abbvieLogo.png",
	"./src/abbvielogo.svg": "./Content/images/src/abbvielogo.svg",
	"./src/appBackground.png": "./Content/images/src/appBackground.png",
	"./src/calender-icon.svg": "./Content/images/src/calender-icon.svg",
	"./src/chart-management-pert-mobile.png": "./Content/images/src/chart-management-pert-mobile.png",
	"./src/chart-management-pert.png": "./Content/images/src/chart-management-pert.png",
	"./src/chart-patients-dissatisfied-mobile.png": "./Content/images/src/chart-patients-dissatisfied-mobile.png",
	"./src/chart-patients-dissatisfied.png": "./Content/images/src/chart-patients-dissatisfied.png",
	"./src/circle-bg-three.svg": "./Content/images/src/circle-bg-three.svg",
	"./src/circle-bg-two.svg": "./Content/images/src/circle-bg-two.svg",
	"./src/circle-bg.svg": "./Content/images/src/circle-bg.svg",
	"./src/clock-icon.svg": "./Content/images/src/clock-icon.svg",
	"./src/education-hover.svg": "./Content/images/src/education-hover.svg",
	"./src/education.svg": "./Content/images/src/education.svg",
	"./src/email-icon.svg": "./Content/images/src/email-icon.svg",
	"./src/epi-education/allison-yang.png": "./Content/images/src/epi-education/allison-yang.png",
	"./src/epi-education/amy-berry.png": "./Content/images/src/epi-education/amy-berry.png",
	"./src/epi-education/andres-gelrud.png": "./Content/images/src/epi-education/andres-gelrud.png",
	"./src/epi-education/darren-brenner.png": "./Content/images/src/epi-education/darren-brenner.png",
	"./src/epi-education/enrique-dominguez.png": "./Content/images/src/epi-education/enrique-dominguez.png",
	"./src/epi-education/epi-play.svg": "./Content/images/src/epi-education/epi-play.svg",
	"./src/epi-education/explore-epi.png": "./Content/images/src/epi-education/explore-epi.png",
	"./src/epi-education/james-moser.png": "./Content/images/src/epi-education/james-moser.png",
	"./src/epi-education/jeannine-mills.png": "./Content/images/src/epi-education/jeannine-mills.png",
	"./src/epi-education/jodie-a-barkin.png": "./Content/images/src/epi-education/jodie-a-barkin.png",
	"./src/epi-education/kofi-clarke.png": "./Content/images/src/epi-education/kofi-clarke.png",
	"./src/epi-education/play-btn.svg": "./Content/images/src/epi-education/play-btn.svg",
	"./src/epi-education/play-hover.svg": "./Content/images/src/epi-education/play-hover.svg",
	"./src/epi-primary-care.svg": "./Content/images/src/epi-primary-care.svg",
	"./src/epiLogo.svg": "./Content/images/src/epiLogo.svg",
	"./src/game_laptop.png": "./Content/images/src/game_laptop.png",
	"./src/global-icon-arrow-down.svg": "./Content/images/src/global-icon-arrow-down.svg",
	"./src/global-icon-back.svg": "./Content/images/src/global-icon-back.svg",
	"./src/global-icon-banner-1.svg": "./Content/images/src/global-icon-banner-1.svg",
	"./src/global-icon-banner-2.svg": "./Content/images/src/global-icon-banner-2.svg",
	"./src/global-icon-banner-3.svg": "./Content/images/src/global-icon-banner-3.svg",
	"./src/global-icon-banner-4.svg": "./Content/images/src/global-icon-banner-4.svg",
	"./src/global-icon-banner-5.svg": "./Content/images/src/global-icon-banner-5.svg",
	"./src/global-icon-home.svg": "./Content/images/src/global-icon-home.svg",
	"./src/global-icon-next.svg": "./Content/images/src/global-icon-next.svg",
	"./src/hamburger-icon.png": "./Content/images/src/hamburger-icon.png",
	"./src/home-checkmark-circle-green.svg": "./Content/images/src/home-checkmark-circle-green.svg",
	"./src/home-checkmark-circle.svg": "./Content/images/src/home-checkmark-circle.svg",
	"./src/home-gi-issue.svg": "./Content/images/src/home-gi-issue.svg",
	"./src/home-icon-34-perc.svg": "./Content/images/src/home-icon-34-perc.svg",
	"./src/home-icon-66-perc.svg": "./Content/images/src/home-icon-66-perc.svg",
	"./src/home-icon-78-perc.svg": "./Content/images/src/home-icon-78-perc.svg",
	"./src/home-icon-clinical-tool.svg": "./Content/images/src/home-icon-clinical-tool.svg",
	"./src/home-icon-education-materials.svg": "./Content/images/src/home-icon-education-materials.svg",
	"./src/home-icon-effects-1.svg": "./Content/images/src/home-icon-effects-1.svg",
	"./src/home-icon-effects-2.svg": "./Content/images/src/home-icon-effects-2.svg",
	"./src/home-icon-effects-3.svg": "./Content/images/src/home-icon-effects-3.svg",
	"./src/home-icon-effects-4.svg": "./Content/images/src/home-icon-effects-4.svg",
	"./src/home-icon-effects-5.svg": "./Content/images/src/home-icon-effects-5.svg",
	"./src/home-icon-effects-6.svg": "./Content/images/src/home-icon-effects-6.svg",
	"./src/home-icon-medical-insights.svg": "./Content/images/src/home-icon-medical-insights.svg",
	"./src/home-icon-peer-stories.svg": "./Content/images/src/home-icon-peer-stories.svg",
	"./src/home-img-game.png": "./Content/images/src/home-img-game.png",
	"./src/home-question-mark.svg": "./Content/images/src/home-question-mark.svg",
	"./src/home-survey-show-1.svg": "./Content/images/src/home-survey-show-1.svg",
	"./src/home-survey-show-2.svg": "./Content/images/src/home-survey-show-2.svg",
	"./src/home-survey-show-3.svg": "./Content/images/src/home-survey-show-3.svg",
	"./src/icon-40-perc-patients.svg": "./Content/images/src/icon-40-perc-patients.svg",
	"./src/icon-70-perc-patients.svg": "./Content/images/src/icon-70-perc-patients.svg",
	"./src/icon-abdominal-pain.svg": "./Content/images/src/icon-abdominal-pain.svg",
	"./src/icon-amylase.svg": "./Content/images/src/icon-amylase.svg",
	"./src/icon-bloating.svg": "./Content/images/src/icon-bloating.svg",
	"./src/icon-blue-checkmark.svg": "./Content/images/src/icon-blue-checkmark.svg",
	"./src/icon-blue-close.svg": "./Content/images/src/icon-blue-close.svg",
	"./src/icon-cardiovascular.svg": "./Content/images/src/icon-cardiovascular.svg",
	"./src/icon-challeng-1.svg": "./Content/images/src/icon-challeng-1.svg",
	"./src/icon-challeng-2.svg": "./Content/images/src/icon-challeng-2.svg",
	"./src/icon-challeng-3.svg": "./Content/images/src/icon-challeng-3.svg",
	"./src/icon-challeng-4.svg": "./Content/images/src/icon-challeng-4.svg",
	"./src/icon-clinical-tool.svg": "./Content/images/src/icon-clinical-tool.svg",
	"./src/icon-decrease-1.svg": "./Content/images/src/icon-decrease-1.svg",
	"./src/icon-decrease-2.svg": "./Content/images/src/icon-decrease-2.svg",
	"./src/icon-decrease-3.svg": "./Content/images/src/icon-decrease-3.svg",
	"./src/icon-decrease-4.svg": "./Content/images/src/icon-decrease-4.svg",
	"./src/icon-diarrhea.svg": "./Content/images/src/icon-diarrhea.svg",
	"./src/icon-education-materials.svg": "./Content/images/src/icon-education-materials.svg",
	"./src/icon-effects-1.svg": "./Content/images/src/icon-effects-1.svg",
	"./src/icon-effects-2.svg": "./Content/images/src/icon-effects-2.svg",
	"./src/icon-effects-3.svg": "./Content/images/src/icon-effects-3.svg",
	"./src/icon-effects-4.svg": "./Content/images/src/icon-effects-4.svg",
	"./src/icon-effects-5.svg": "./Content/images/src/icon-effects-5.svg",
	"./src/icon-effects-6.svg": "./Content/images/src/icon-effects-6.svg",
	"./src/icon-flatulence.svg": "./Content/images/src/icon-flatulence.svg",
	"./src/icon-follow-up-1.svg": "./Content/images/src/icon-follow-up-1.svg",
	"./src/icon-follow-up-2.svg": "./Content/images/src/icon-follow-up-2.svg",
	"./src/icon-follow-up-3.svg": "./Content/images/src/icon-follow-up-3.svg",
	"./src/icon-follow-up-4.svg": "./Content/images/src/icon-follow-up-4.svg",
	"./src/icon-glucagon.svg": "./Content/images/src/icon-glucagon.svg",
	"./src/icon-home.svg": "./Content/images/src/icon-home.svg",
	"./src/icon-how-perts-work.svg": "./Content/images/src/icon-how-perts-work.svg",
	"./src/icon-impaired-growth.svg": "./Content/images/src/icon-impaired-growth.svg",
	"./src/icon-info.svg": "./Content/images/src/icon-info.svg",
	"./src/icon-insulin.svg": "./Content/images/src/icon-insulin.svg",
	"./src/icon-lifestyle.svg": "./Content/images/src/icon-lifestyle.svg",
	"./src/icon-lipase.svg": "./Content/images/src/icon-lipase.svg",
	"./src/icon-management.svg": "./Content/images/src/icon-management.svg",
	"./src/icon-medical-insights.svg": "./Content/images/src/icon-medical-insights.svg",
	"./src/icon-medical-management.svg": "./Content/images/src/icon-medical-management.svg",
	"./src/icon-mortality.svg": "./Content/images/src/icon-mortality.svg",
	"./src/icon-number-1.png": "./Content/images/src/icon-number-1.png",
	"./src/icon-number-1.svg": "./Content/images/src/icon-number-1.svg",
	"./src/icon-number-2.png": "./Content/images/src/icon-number-2.png",
	"./src/icon-number-2.svg": "./Content/images/src/icon-number-2.svg",
	"./src/icon-number-3.png": "./Content/images/src/icon-number-3.png",
	"./src/icon-number-3.svg": "./Content/images/src/icon-number-3.svg",
	"./src/icon-number-4.png": "./Content/images/src/icon-number-4.png",
	"./src/icon-number-4.svg": "./Content/images/src/icon-number-4.svg",
	"./src/icon-nutritional.svg": "./Content/images/src/icon-nutritional.svg",
	"./src/icon-osteoporosis.svg": "./Content/images/src/icon-osteoporosis.svg",
	"./src/icon-pancreatic.svg": "./Content/images/src/icon-pancreatic.svg",
	"./src/icon-peer-stories.svg": "./Content/images/src/icon-peer-stories.svg",
	"./src/icon-pert-dosing-pie-1.svg": "./Content/images/src/icon-pert-dosing-pie-1.svg",
	"./src/icon-pert-dosing-pie-2.svg": "./Content/images/src/icon-pert-dosing-pie-2.svg",
	"./src/icon-pert-dosing-pie-3.svg": "./Content/images/src/icon-pert-dosing-pie-3.svg",
	"./src/icon-plus-blue.svg": "./Content/images/src/icon-plus-blue.svg",
	"./src/icon-plus-purple.svg": "./Content/images/src/icon-plus-purple.svg",
	"./src/icon-prescribing-pert-1.svg": "./Content/images/src/icon-prescribing-pert-1.svg",
	"./src/icon-prescribing-pert-2.svg": "./Content/images/src/icon-prescribing-pert-2.svg",
	"./src/icon-prescribing-pert-3.svg": "./Content/images/src/icon-prescribing-pert-3.svg",
	"./src/icon-prescribing-pert-4.svg": "./Content/images/src/icon-prescribing-pert-4.svg",
	"./src/icon-protease.svg": "./Content/images/src/icon-protease.svg",
	"./src/icon-purple-checkmark.svg": "./Content/images/src/icon-purple-checkmark.svg",
	"./src/icon-question-mark.svg": "./Content/images/src/icon-question-mark.svg",
	"./src/icon-safety-pert-1.svg": "./Content/images/src/icon-safety-pert-1.svg",
	"./src/icon-safety-pert-2.svg": "./Content/images/src/icon-safety-pert-2.svg",
	"./src/icon-safety-pert-3.svg": "./Content/images/src/icon-safety-pert-3.svg",
	"./src/icon-safety-pert-4.svg": "./Content/images/src/icon-safety-pert-4.svg",
	"./src/icon-sarcopenia.svg": "./Content/images/src/icon-sarcopenia.svg",
	"./src/icon-somatostatin.svg": "./Content/images/src/icon-somatostatin.svg",
	"./src/icon-steatorrhea.svg": "./Content/images/src/icon-steatorrhea.svg",
	"./src/icon-survey-show-1.svg": "./Content/images/src/icon-survey-show-1.svg",
	"./src/icon-survey-show-2.svg": "./Content/images/src/icon-survey-show-2.svg",
	"./src/icon-survey-show-3.svg": "./Content/images/src/icon-survey-show-3.svg",
	"./src/icon-symptoms-suspect-1.svg": "./Content/images/src/icon-symptoms-suspect-1.svg",
	"./src/icon-symptoms-suspect-2.svg": "./Content/images/src/icon-symptoms-suspect-2.svg",
	"./src/icon-symptoms-suspect-3.svg": "./Content/images/src/icon-symptoms-suspect-3.svg",
	"./src/icon-symptoms-suspect-4.svg": "./Content/images/src/icon-symptoms-suspect-4.svg",
	"./src/icon-under-recognized-1.svg": "./Content/images/src/icon-under-recognized-1.svg",
	"./src/icon-under-recognized-2.svg": "./Content/images/src/icon-under-recognized-2.svg",
	"./src/icon-under-recognized-3.svg": "./Content/images/src/icon-under-recognized-3.svg",
	"./src/icon-under-recognized-4.svg": "./Content/images/src/icon-under-recognized-4.svg",
	"./src/icon-unexplained-weight-loss.svg": "./Content/images/src/icon-unexplained-weight-loss.svg",
	"./src/icov-plus-blue.svg": "./Content/images/src/icov-plus-blue.svg",
	"./src/img-acute-pancreatitis-mobile.jpg": "./Content/images/src/img-acute-pancreatitis-mobile.jpg",
	"./src/img-acute-pancreatitis-pie-1.jpg": "./Content/images/src/img-acute-pancreatitis-pie-1.jpg",
	"./src/img-acute-pancreatitis-pie-2.jpg": "./Content/images/src/img-acute-pancreatitis-pie-2.jpg",
	"./src/img-acute-pancreatitis.jpg": "./Content/images/src/img-acute-pancreatitis.jpg",
	"./src/img-cd-pie.png": "./Content/images/src/img-cd-pie.png",
	"./src/img-celiac-disease.jpg": "./Content/images/src/img-celiac-disease.jpg",
	"./src/img-celiac-pie1.jpg": "./Content/images/src/img-celiac-pie1.jpg",
	"./src/img-celiac-pie2.jpg": "./Content/images/src/img-celiac-pie2.jpg",
	"./src/img-celiac-pie3.jpg": "./Content/images/src/img-celiac-pie3.jpg",
	"./src/img-cell-type-1.jpg": "./Content/images/src/img-cell-type-1.jpg",
	"./src/img-cell-type-2.jpg": "./Content/images/src/img-cell-type-2.jpg",
	"./src/img-cell-type-3.jpg": "./Content/images/src/img-cell-type-3.jpg",
	"./src/img-cell-type-4.jpg": "./Content/images/src/img-cell-type-4.jpg",
	"./src/img-cell-type-mobile.jpg": "./Content/images/src/img-cell-type-mobile.jpg",
	"./src/img-chronic-pancreatitis-mobile.jpg": "./Content/images/src/img-chronic-pancreatitis-mobile.jpg",
	"./src/img-chronic-pancreatitis.jpg": "./Content/images/src/img-chronic-pancreatitis.jpg",
	"./src/img-crohn-disease-mobile.jpg": "./Content/images/src/img-crohn-disease-mobile.jpg",
	"./src/img-crohn-disease.jpg": "./Content/images/src/img-crohn-disease.jpg",
	"./src/img-cystic-fibrosis-2-mobile.jpg": "./Content/images/src/img-cystic-fibrosis-2-mobile.jpg",
	"./src/img-cystic-fibrosis-2.jpg": "./Content/images/src/img-cystic-fibrosis-2.jpg",
	"./src/img-cystic-fibrosis-mobile.jpg": "./Content/images/src/img-cystic-fibrosis-mobile.jpg",
	"./src/img-cystic-fibrosis.jpg": "./Content/images/src/img-cystic-fibrosis.jpg",
	"./src/img-diabetes-mobile.jpg": "./Content/images/src/img-diabetes-mobile.jpg",
	"./src/img-diabetes.jpg": "./Content/images/src/img-diabetes.jpg",
	"./src/img-etiologies-epi.svg": "./Content/images/src/img-etiologies-epi.svg",
	"./src/img-gastric-1.png": "./Content/images/src/img-gastric-1.png",
	"./src/img-gastric-2.png": "./Content/images/src/img-gastric-2.png",
	"./src/img-gastric-3.png": "./Content/images/src/img-gastric-3.png",
	"./src/img-gastric-4.png": "./Content/images/src/img-gastric-4.png",
	"./src/img-gastric-pie-1.png": "./Content/images/src/img-gastric-pie-1.png",
	"./src/img-gastric-pie-2.png": "./Content/images/src/img-gastric-pie-2.png",
	"./src/img-gi-issues.png": "./Content/images/src/img-gi-issues.png",
	"./src/img-moa.png": "./Content/images/src/img-moa.png",
	"./src/img-mov-mobile.png": "./Content/images/src/img-mov-mobile.png",
	"./src/img-pancreatectomy-1.png": "./Content/images/src/img-pancreatectomy-1.png",
	"./src/img-pancreatectomy-2.png": "./Content/images/src/img-pancreatectomy-2.png",
	"./src/img-pancreatectomy-3.png": "./Content/images/src/img-pancreatectomy-3.png",
	"./src/img-pancreatectomy-4.png": "./Content/images/src/img-pancreatectomy-4.png",
	"./src/img-pancreatic-pie-1.png": "./Content/images/src/img-pancreatic-pie-1.png",
	"./src/img-pancreatic-pie-2.png": "./Content/images/src/img-pancreatic-pie-2.png",
	"./src/img-pert-dosing-admin-mobile.png": "./Content/images/src/img-pert-dosing-admin-mobile.png",
	"./src/img-pert-dosing-admin.png": "./Content/images/src/img-pert-dosing-admin.png",
	"./src/img-type1-pie.png": "./Content/images/src/img-type1-pie.png",
	"./src/img-type2-pie.png": "./Content/images/src/img-type2-pie.png",
	"./src/key-circle-icon.svg": "./Content/images/src/key-circle-icon.svg",
	"./src/menu-close-icon.png": "./Content/images/src/menu-close-icon.png",
	"./src/minus.svg": "./Content/images/src/minus.svg",
	"./src/mobileBackground.png": "./Content/images/src/mobileBackground.png",
	"./src/phone-icon.svg": "./Content/images/src/phone-icon.svg",
	"./src/pie-34-pec.png": "./Content/images/src/pie-34-pec.png",
	"./src/pie-66-pec.png": "./Content/images/src/pie-66-pec.png",
	"./src/pie-78-pec.png": "./Content/images/src/pie-78-pec.png",
	"./src/plus.svg": "./Content/images/src/plus.svg",
	"./src/privacy-choices-white-transparent-bg_120w.png": "./Content/images/src/privacy-choices-white-transparent-bg_120w.png",
	"./src/resources/exocrine-pancreatic-insufficiency.png": "./Content/images/src/resources/exocrine-pancreatic-insufficiency.png",
	"./src/resources/info-icon.svg": "./Content/images/src/resources/info-icon.svg",
	"./src/resources/pdf-consider-the-pancreas.png": "./Content/images/src/resources/pdf-consider-the-pancreas.png",
	"./src/resources/pdf-epi-in-pancreatic-cancer.png": "./Content/images/src/resources/pdf-epi-in-pancreatic-cancer.png",
	"./src/resources/pdf-epi-pancreatic-cancer.jpg": "./Content/images/src/resources/pdf-epi-pancreatic-cancer.jpg",
	"./src/resources/pdf-epi-primary-care.jpg": "./Content/images/src/resources/pdf-epi-primary-care.jpg",
	"./src/searchBackground.png": "./Content/images/src/searchBackground.png",
	"./src/section-header-bg.png": "./Content/images/src/section-header-bg.png",
	"./src/section-header-mobile-bg.png": "./Content/images/src/section-header-mobile-bg.png",
	"./src/us-map.svg": "./Content/images/src/us-map.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./Content/images sync recursive \\.(png%7Cjpe?g%7Csvg)$";